import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const dispatchedDriverStatesAdapter = getAdapter({ idFieldName: 'value' });

const dispatchedDriverStatesSlice = createSlice({
  name: 'dispatchedDriverStates',
  initialState: dispatchedDriverStatesAdapter.getInitialState(),
  reducers: {
    setDispatchedDriverStates: (state, { payload: { dispatchedDriverStates } }) => {
      dispatchedDriverStatesAdapter.setAll(state, dispatchedDriverStates);
    },
  },
});

const selectors = dispatchedDriverStatesAdapter
  .getSelectors(({ dispatchedDriverStates }) => dispatchedDriverStates);

export const getDispatchedDriverStates = (state) => selectors.selectAll(state);

export const {
  setDispatchedDriverStates,
} = dispatchedDriverStatesSlice.actions;

export default dispatchedDriverStatesSlice.reducer;